import {
  isPossiblePhoneNumber,
  parsePhoneNumberFromString,
  validatePhoneNumberLength,
} from "libphonenumber-js";

export function getInputFieldValue(inputFieldRef) {
  if (!inputFieldRef || !inputFieldRef.value) return "";
  return inputFieldRef.value;
}

export const isValidConfirmationCode = (value: string): boolean => {
  if (!/^\d+$/.test(value)) return false;

  if (value.length !== 6) return false;

  return true;
};

export const isEmail = (value) => {
  if (!value) {
    return false;
  }
  const lowercasedValue = value.toLowerCase();

  if (lowercasedValue.startsWith("@")) {
    return false;
  }

  if (lowercasedValue.includes("@@")) {
    return false;
  }

  // eslint-disable-next-line security/detect-unsafe-regex -- no harm regex
  return !!/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
    lowercasedValue
  );
};

export const isTelephone = (value) => {
  const phoneNumber = parsePhoneNumberFromString(value);

  const isPossiblePhoneNumberCheck = isPossiblePhoneNumber(
    value,
    phoneNumber?.country
  );

  if (phoneNumber?.country === "CI" && value.startsWith("+225")) {
    if (phoneNumber?.nationalNumber?.length === 10) {
      return true;
    }
    return false;
  }

  if (phoneNumber?.country === "SK") {
    if (
      phoneNumber?.nationalNumber?.length !== 9 ||
      !isPossiblePhoneNumberCheck
    ) {
      return false;
    }
  }

  if (phoneNumber?.country === "PL") {
    if (
      phoneNumber?.nationalNumber?.length !== 9 ||
      !isPossiblePhoneNumberCheck
    ) {
      return false;
    }
  }

  if (value.startsWith("+61")) {
    if (
      phoneNumber?.nationalNumber?.length !== 9 &&
      isPossiblePhoneNumberCheck
    ) {
      return false;
    }
  }

  const isPhoneNumberValid = validatePhoneNumberLength(
    value,
    phoneNumber?.country
  );

  if (phoneNumber) {
    return isPossiblePhoneNumberCheck && !isPhoneNumberValid;
  }

  return false;
};
